<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Brand Area  -->
    <div class="rwt-brand-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="下载中心"
                data-aos="fade-up"
            />
          </div>
        </div>

        <div class="row mt--35 row--20">
          <div class="col-lg-10 offset-lg-1">
            <ProductDownloadAccordion
                id="accordionExampleFour"
                accordion-style-class="rn-accordion-04"
                data-aos="fade-up"
                data-aos-delay="60"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- End Brand Area  -->



  </Layout>
</template>
<script>
import Layout from "../../components/common/Layout";
import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import ProductDownloadAccordion from "./ProductDownloadAccordion";
export default {
  name: 'ProductDownload',
  components: {ProductDownloadAccordion, Layout,SectionTitle},

  data() {
    return {

    }
  },
  methods:{

  }
}
</script>

<style scoped>

</style>